import {Component, Input} from "@angular/core";
import {CubeDefinitionData} from "../../framework/bi/cube-definition.data";
import {OrderProcessorCapability} from "../../order-processing/order_processor/order-processor.data";

@Component({
    selector: "wbo-bi-filter-extended-fields",
    templateUrl: "./filter-extended-fields.component.html"
})
export class FilterExtendedFieldsComponent {

    OrderProcessorCapability = OrderProcessorCapability;

    @Input() cubeDefinition: CubeDefinitionData;

}
